module.exports = __webpack_public_path__ + "static/media/success-tick-green-mark.583cac49.svg";